import { ReduceStore } from 'flux/utils';
import { Record, Map } from 'immutable';
import AppDispatcher from '../AppDispatcher';
import Constants from '../Constants';

export class Role extends Record(
  {
    id: null,
    roleClass: '',
    availableActions: [],
  }) {
}

function addRolesFromOrganization(state, organization) {
  const newValues = new Map(organization.roles.map(role =>
    [role.id, new Role({
      id: role.id,
      roleClass: role.role_class,
      availableActions: role.available_actions,
    })])
  );
  return state.merge(newValues);
}

function addRolesFromUser(state, user) {
  const newValues = new Map(user.memberships.map(membership =>
    [membership.role.id, new Role({
      id: membership.role.id,
      roleClass: membership.role.role_class,
      availableActions: membership.role.available_actions,
    })])
  );
  return state.merge(newValues);
}

class RoleStore extends ReduceStore {
  getInitialState() {
    return new Map();
  }

  reduce(state, action) {
    switch (action.actionType) {
      case Constants.Admin.ORGANIZATION_LOADED:
        return addRolesFromOrganization(state, action.organization);
      case Constants.Admin.CURRENT_USER_LOADED:
        return addRolesFromUser(state, action.user);
      default:
        return state;
    }
  }

  get(id, defaultValue = null) {
    return this.getState().get(id, defaultValue);
  }

}

const instance = new RoleStore(AppDispatcher);
export default instance;
